import { CurrencySymbolsConfig } from "../state";

const pricePresenter = (price: number, currencySymbols: CurrencySymbolsConfig, locale?: string) => {
  const result = new Intl.NumberFormat('en-GB', { style: 'currency', currency: locale }).format(price);
  if (locale && currencySymbols[locale]) {
    return result.replace(locale, currencySymbols[locale])
  }
  return result
}

export default pricePresenter;